import React, { useLayoutEffect, useRef } from "react"
import { ThemeProvider } from "styled-components"
import { Provider } from "react-redux"
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom"
import { SplitFactoryProvider } from "@splitsoftware/splitio-react"
import { generateStore } from "@theguarantors/frontend-core/dist/actions"
import { createSentryMiddleware } from "@theguarantors/frontend-utils"
import { NotFound as NotFoundPage } from "@theguarantors/ui-kit-v2"
import { reducers } from "./reducers"
import { theme } from "@theguarantors/ui-kit-v2/dist/design-system"
import { Application } from "@theguarantors/ui-kit-v2/dist/layout/one-column-form"
import { LandingPage, NoApartmentPage, UnenrolledPage } from "./pages"
import config from "./config"
import { BreakpointsProvider } from "@theguarantors/ui-kit-v2/dist/design-system/hooks"
import { ThankYouPage } from "./pages/ThankYou"
import splitIoConfig from "./config/configuration"

const isDevelopment: boolean = process.env.REACT_APP_ENV !== "production"
const store = generateStore(reducers, !isDevelopment ? [createSentryMiddleware()] : [])
const NotFound: React.FC = () => (
  <Application>
    <NotFoundPage />
  </Application>
)

const BrowserHelper = () => {
  const location = useLocation()
  const prevPath = useRef<string | null>(null)

  useLayoutEffect(
    () => {
      if (location.pathname !== prevPath.current) {
        prevPath.current = location.pathname;

        // eslint-disable-next-line
        window?.analytics?.page()
      }
    },
    [location.pathname]
  )

  return null
}

const splitIOConfig = splitIoConfig().splitIO
export const App: React.FC = () => (
  <Provider store={store}>
    <SplitFactoryProvider config={splitIOConfig}>
      <ThemeProvider theme={theme}>
        <BreakpointsProvider>
          <BrowserRouter>
            <BrowserHelper />
            <Routes>
              <Route>
                <Route element={<BrowserHelper />} />
                <Route path={config.landingPath} element={<LandingPage />} />
                <Route path={config.unenrolledBuildingPath} element={<UnenrolledPage />} />
                <Route path={config.noApartmentPath} element={<NoApartmentPage />} />
                <Route path={config.thanksPath} element={<ThankYouPage />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </BreakpointsProvider>
      </ThemeProvider>
    </SplitFactoryProvider>
  </Provider>
)
